import { render, staticRenderFns } from "./LegalConfig.vue?vue&type=template&id=38a6dea9&"
import script from "./LegalConfig.vue?vue&type=script&lang=js&"
export * from "./LegalConfig.vue?vue&type=script&lang=js&"
import style0 from "./LegalConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports